import {	BRAND_SETTINGS_FORM_MODULE_ID } from 'root/src/shared/descriptions/modules/moduleIds'
import { ACCOUNT_SETTINGS_ROUTE_ID } from 'root/src/shared/descriptions/routes/routeIds'
import setBrandSettingsSchema from 'root/src/shared/descriptions/formSchemas/setBrandSettingsSchema'
import brandSettingsSelector from 'root/src/client/logic/form/selectors/brandSettingsSelector'

export const brandSettingsFields = [
	{
		fieldId: 'brandName',
		inputType: 'text',
		labelFieldText: [
			{
				text: 'Publisher Name',
			},
		],
		required: true,
	},
	{
		fieldId: 'brandWebsite',
		inputType: 'text',
		labelFieldText: [
			{
				text: 'Website',
			},
		],
		required: true,
	},
	{
		fieldId: 'brandTwitter',
		inputType: 'text',
		labelFieldText: [
			{
				text: 'Twitter',
			},
		],
		placeholder: 'Optional',
		required: false,
	},
	{
		fieldId: 'brandLogoUrl',
		inputType: 'imageInput',
		attachmentText: 'Upload Photo +',
		attachmentFormats: ['jpg', 'jpeg', 'png', 'svg'],
		subFieldText: 'Minimum image size is 130x130',
		required: false,
		crop: {
			aspect: 1,
			adjustDisplay: true,
			buttonText: 'Crop Image',
			cropValidationFn: (coordinates) => {
				const { width } = coordinates
				return !(width < 130)
			},
			cropErrorMessage: 'Minimum dimensions: 130x130',
		},
	},
]

export default {
	[BRAND_SETTINGS_FORM_MODULE_ID]: {
		moduleType: 'form',
		schema: setBrandSettingsSchema,
		title: 'Publisher Settings',
		prePopulateForm: brandSettingsSelector,
		prePopulateFormOn: 'brandSettings',
		fields: brandSettingsFields,
		submits: [
			{
				label: 'Save',
				buttonType: 'primaryButton',
			},
		],
		links: [
			{
				routeId: ACCOUNT_SETTINGS_ROUTE_ID,
				label: 'Go Back',
			},
		],
	},
}
